/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Button from '@ui-elements/Button';
import Typography from '@mui/material/Typography';
import { ButtonProps } from '@mui/material/Button';
import { FONT_SIZES } from '~/assets/styles/base';

type StyledButtonProps = {
  $styles?: {};
};

const StyledButton = styled(Button)<StyledButtonProps>`
  display: flex;
  font-size: ${FONT_SIZES.body3};
  margin-right: 12px;
  ${({ $styles }) => $styles}; // Override
`;

type Props = {
  variant?: ButtonProps['variant'];
  label: string;
  href: string;
  styles?: {};
};

const LinkButton: React.FC<Props & ButtonProps> = ({
  variant = 'text',
  label,
  href,
  styles = {},
  ...props
}): JSX.Element => {
  const navigate = useNavigate();
  return (
    <StyledButton
      data-testid="uiParts-LinkButton"
      variant={variant}
      onClick={() => navigate(href)}
      $styles={styles}
      {...props}
    >
      <Typography sx={{ fontSize: 'inherit' }}>{label}</Typography>
    </StyledButton>
  );
};

export default LinkButton;
